import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { BehaviorSubject } from 'rxjs';

const APP_TITLE = environment.pageTitle;
const SEPARATOR = ' | ';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  readCount: number;
  private readonly messageCountSubject = new BehaviorSubject<number>(0);
  readCountValue = this.messageCountSubject.asObservable();
  static ucFirst(string) {
    if (!string) {
      return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
  ) {}

  init() {
    this.readCountValue.subscribe((count) => {
      this.readCount = count;
      this.updateTitle();
    });
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        // map(route => route.firstChild),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        switchMap((route) => route.data),
        map((data) => {
          if (data.title) {
            // If a route has a title set (e.g. data: {title: 'Foo'}) then we use it
            return data.title;
          } else {
            // If not, we do a little magic on the url to create an approximation
            return this.router.url.split('/').reduce((acc, frag) => {
              if (acc && frag) {
                acc += SEPARATOR;
              }
              return acc + TitleService.ucFirst(frag);
            });
          }
        }),
      )
      .subscribe((pathString) =>
        this.titleService.setTitle(this.formatTitle(pathString)),
      );
  }
  private updateTitle() {
    const SEPARATOR = ' | ';
    const currentTitle = this.titleService.getTitle().split(SEPARATOR).pop(); // Get last part of title
    this.titleService.setTitle(this.formatTitle(currentTitle));
  }
  private formatTitle(pageTitle: string): string {
    return this.readCount > 0 ? `🔴(${this.readCount}) ${APP_TITLE}${SEPARATOR}${pageTitle}`
      : `${APP_TITLE}${SEPARATOR}${pageTitle}`;
  }
  updateMessageCount(count: number) {
    this.messageCountSubject.next(count); // Update the count
  }
}
